import React, { useState } from 'react';
import styled from 'styled-components';

import { Input } from '../elements';
import LocationSuggestion from '../global/LocationSuggestion';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const Search = ({
  vendorNameSearchInput,
  setVendorNameSearchInput,
  placeNameSearchInput,
  setPlaceNameSearchInput,
  setCityFilter,
}) => {
  const [city, setCity] = useState('');
  return (
    <Wrapper>
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-4">
            <Input
              label="Place Name"
              type="text"
              id="GlobalSearch_PlaceName"
              value={placeNameSearchInput}
              onChange={event => setPlaceNameSearchInput(event.target.value)}
              placeholder="Start entering place name..."
            />
          </div>
          <div className="column is-4">
            <Input
              label="Company Name"
              type="text"
              id="GlobalSearch_CompanyName"
              value={vendorNameSearchInput}
              onChange={event => setVendorNameSearchInput(event.target.value)}
              placeholder="Start entering company name..."
            />
          </div>
          <div className="column is-4">
            <div className="field">
              <label className="label">City / Suburb</label>
              <div className="control">
                <LocationSuggestion
                  initialValue={city}
                  onSelect={data => {
                    setCityFilter(data.name);
                    setCity(data.name);
                  }}
                  onHandleClear={() => {
                    setCityFilter(null);
                    setCity('');
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};

export default Search;
